export const VALUES_TABLE_LABELS = {
	TABLE_TITLE: 'Label values',
	TABLE_CAPTION: 'Table of label values with dashboard visibility toggles',
	COLUMN_VALUE: 'Value',
	COLUMN_DASHBOARD_VISIBILITY: 'Include in Dashboard Data',
	COLUMN_DASHBOARD_VISIBILITY_TOOLTIP:
		'Controls whether this value appears in dashboard reports and filters',
	COLUMN_ACTIONS: '',
	COLUMN_ACTIONS_SR: 'Actions',
	DELETE_VALUE_TOOLTIP: 'Delete value',
	TOGGLE_VISIBLE_ARIA: 'Toggle dashboard visibility',
	EMPTY_STATE_TITLE: 'No values added yet',
	EMPTY_STATE_DESCRIPTION: 'Add values to enhance filtering in dashboards and reports.',
	NEW_VALUE_BADGE: 'New'
} as const;
